"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectBlockchain = exports.ProjectBudget = void 0;
var ProjectBudget;
(function (ProjectBudget) {
    ProjectBudget["< 10"] = "< 10";
    ProjectBudget["10-25"] = "10-25";
    ProjectBudget["25-50"] = "25-50";
    ProjectBudget["50-100"] = "50-100";
    ProjectBudget["100-250"] = "100-250";
    ProjectBudget["> 250"] = "> 250";
})(ProjectBudget || (exports.ProjectBudget = ProjectBudget = {}));
var ProjectBlockchain;
(function (ProjectBlockchain) {
    ProjectBlockchain["ARBITRUM"] = "ARBITRUM";
    ProjectBlockchain["AVALANCHE"] = "AVALANCHE";
    ProjectBlockchain["BINANCE"] = "BINANCE";
    ProjectBlockchain["ETHEREUM"] = "ETHEREUM";
    ProjectBlockchain["IMMUTABLE"] = "IMMUTABLE";
    ProjectBlockchain["OASYS"] = "OASYS";
    ProjectBlockchain["OPTIMISM"] = "OPTIMISM";
    ProjectBlockchain["POLYGON"] = "POLYGON";
    ProjectBlockchain["OTHER"] = "OTHER";
})(ProjectBlockchain || (exports.ProjectBlockchain = ProjectBlockchain = {}));
//# sourceMappingURL=create.js.map